import { render, staticRenderFns } from "./AppPaginatedTable.vue?vue&type=template&id=6c8d7f6b&"
import script from "./AppPaginatedTable.vue?vue&type=script&lang=js&"
export * from "./AppPaginatedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports